import { RouteRecordRaw } from "vue-router";
import systemConfiguration from "@/app/views/pages/SystemConfiguration/SystemConfiguration.vue";
import LayoutV1 from "@/core/views/designlanguage/v1/LayoutV1.vue";
/**
 * Define Application specific routes
 */
const appRouter: RouteRecordRaw[] = [
  {
    path: "/systemConfiguration",
    component: LayoutV1,
    children: [
      {
        path: "",
        name: "systemConfiguration",
        component: systemConfiguration,
        meta: {
          title: "System Configuration",
          permission: "AbpIdentity.Roles"
        }
      }
    ]
  }
  //   {
  //     path: "/books",
  //     component: MainLayout,
  //     children: [
  //       {
  //         path: "",
  //         name: "BooksGrid",
  //         component: BooksGrid,
  //         meta: {
  //           title: "Books",
  //           permission: "CoatsDigital.App.Books"
  //         }
  //       },
  //       {
  //         path: "create",
  //         name: "BookFormCreate",
  //         component: BookForm,
  //         meta: {
  //           title: "Create Book",
  //           permission: "CoatsDigital.App.Books.Create"
  //         }
  //       },
  //       {
  //         path: "edit/:id",
  //         name: "BookFormEdit",
  //         component: BookForm,
  //         meta: {
  //           title: "Edit Book",
  //           permission: "CoatsDigital.App.Books.Update"
  //         }
  //       }
  //     ]
  //   }
];

export default appRouter;
